import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "../KioskShopDetailContent.module.css";

const KioskShopDetailContent = () => {
  return (
    <div className={styles.Detail}>
      <div className={styles.TitleRow}>
        <h2 className={styles.Title}  style={{ width: "50%" }}>
          <Skeleton count={1} />
        </h2>
        <div className={styles.Slot}>
          <Skeleton count={1} />
        </div>
      </div>
      <div className={styles.DetailBox}>
        <div className={styles.DetailBoxInner}>
          <div className={styles.Logo}>
            <Skeleton height={67} />
          </div>

          <div className={styles.Thumbnail}>
            <Skeleton height={335} />
          </div>

          <div className={styles.Content}>
            <Skeleton count={15} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KioskShopDetailContent;
